import { Styles, css, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: css`
    display: flex;
    align-items: center;
    position: relative;
    z-index: 0;
  `,
  tooltipSize: css`
    max-width: 180px;
    text-align: center;
  `,
  tooltip: css`
    &:not(:first-child) {
      margin-left: -4px;
    }

    &:hover {
      z-index: 10;
    }
  `,
  dot: ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    border: 1px solid ${theme.colors.neutral.gray[0]};
    position: relative;
    cursor: pointer;
    transition: 0.1s ease;
    padding: 4px;
  `,
  dotActive: ({ theme }) => css`
    background-color: ${theme.colors.secondary.sky[20]};
    color: white;

    &:hover {
      background-color: ${theme.colors.secondary.sky[30]};
    }
  `,
  dotInactive: ({ theme }) => css`
    background-color: ${theme.colors.neutral.gray[10]};
    color: ${theme.colors.neutral.gray[50]};
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
